/**
 * DOM関連メソッド
 */
export default class DomUtils {
  /**
   * DOM要素の矩形を絶対座標に変換して返す
   *
   * @param element 対象のDOM要素
   * @param parentElement 座標の基準となる親DOM要素
   * @returns DOMRect(絶対座標に変換した値)
   */
  public static getAbsoluteRect(element: HTMLElement, parentElement?: HTMLElement): DOMRect {
    const rect = element.getBoundingClientRect()

    // 親要素指定のある場合
    if (parentElement) {
      const parentRect = parentElement.getBoundingClientRect()
      return new DOMRect(
        rect.x - parentRect.x + parentElement.scrollLeft,
        rect.y - parentRect.y + parentElement.scrollTop,
        rect.width,
        rect.height
      )
    }

    // 親要素指定がない場合
    return new DOMRect(rect.x + window.scrollX, rect.y + window.scrollY, rect.width, rect.height)
  }
}
